import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, transacoesCompraVenda } = obj
  const valorFormatado = transacoesCompraVenda.valorFormatado
  const response = await http[verb]('/transacoesCompraVenda', transacoesCompraVenda)

  if (response !== null) {
    transacoesCompraVenda.valor = valorFormatado
    if (response.data.data !== undefined) {
      transacoesCompraVenda.id = response.data.data.id
      update(context, { ...transacoesCompraVenda })
      return Promise.resolve()
    } else {
      return response.data
    }
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/transacoesCompraVenda/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data)
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/transacoesCompraVenda')
  if (response !== null) {
    const transacoesCompraVenda = response.data
    commit('SET_LIST', transacoesCompraVenda)
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { transacoesCompraVenda: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/transacoesCompraVenda/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

const processAuth = async ({ commit, state }, data) => {
  return new Promise(async (resolve) => {
    const { verb, authenticationRequest } = data
    const response = await http[verb]('/acessodigital/message', authenticationRequest)
    if (response !== null && response.data !== null) {
      resolve(response.data.data)
    }
  })
}

const exibirNovaConta = async (context, id) => {
  const response = await http.get(`/config/exibirNovaConta`)
  if (response.data !== undefined && response.data.data !== undefined) {
    return Promise.resolve(response.data.data)
  }
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove,
  processAuth,
  exibirNovaConta
}



// WEBPACK FOOTER //
// ./src/features/admin/comprarFichas/store/actions.js